import QmsDashboard from "./QmsDashboard";
import QmsScaffoldPage from "./QmsScaffoldPage";
import QmsDocumentTypes from "./QmsDocumentTypes";
import QmsDocumentCategories from "./QmsDocumentCategories";
import QmsDocumentLibrary from "./QmsDocumentLibrary";
import QmsQuestionBank from "./QmsQuestionBank";
import QmsQuizManager from "./QmsQuizManager";
import QmsMyVault from "./QmsMyVault";
import QmsSharedWithMe from "./QmsSharedWithMe";
import QmsPublishDocuments from "./QmsPublishDocuments";
import QmsMyLearnings from "./QmsMyLearnings";
import QmsMyLearning from "./QmsMyLearning";
import QmsReports from "./QmsReports";

export {
  QmsDocumentTypes,
  QmsDocumentCategories,
  QmsDocumentLibrary,
  QmsQuestionBank,
  QmsQuizManager,
  QmsMyVault,
  QmsSharedWithMe,
  QmsPublishDocuments,
  QmsMyLearnings,
  QmsMyLearning,
};

export { QmsDashboard };
export { QmsReports };
export { default as QmsDocumentControl } from "./QmsDocumentControl";
export const QmsComplianceReport = () => <QmsReports />;
export const QmsCreateChangeRequest = () => (
  <QmsScaffoldPage screenKey="createChangeRequest" />
);
export const QmsChangeRequests = () => (
  <QmsScaffoldPage screenKey="changeRequests" />
);
export const QmsReadingList = () => <QmsScaffoldPage screenKey="readingList" />;
export const QmsMyRecords = () => <QmsMyLearnings />;
